"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
const functions_1 = require("../../functions");
function propertyDefinition(pvs) {
    const temperaturesOut = (0, functions_1.getTemperaturesOut)(pvs);
    return [
        ...temperaturesOut.map((_, i) => ({
            sort_no: i,
            name: (0, functions_1.temperatureOutName)(i),
            group: "",
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.fromString("temperatureflow=0"),
            value: [],
            fieldName: functions_1.inputTemperaturePrefix
        }))
    ];
}
//# sourceMappingURL=temperatures-out-definition.js.map